// File: packages/calculator/components/QuickPicks.tsx

import React, { useMemo } from 'react';
import { Button, Tooltip } from '@dopomogai/ui';
import { useCalculator } from '@dopomogai/agent-kit';
import { fmtMoney } from '@dopomogai/agent-kit';

/**
 * A component that displays a compact row of "recommended" features
 * for fast selection by the user.
 */
export function QuickPicks() {
  const { spec, state, actions } = useCalculator();

  const recommendedPicks = useMemo(() => {
    return spec.groups
      .flatMap((g) => g.features)
      .filter((f) => f.recommended === true && f.visibility !== 'advanced');
  }, [spec.groups]);

  if (recommendedPicks.length === 0) {
    return null;
  }

  return (
    <section>
      <div className="mb-3 font-extrabold text-slate-900">3. Add quick picks</div>
      <div className="flex flex-wrap gap-2">
        {recommendedPicks.map((pick) => {
          const isActive = state.selectedModuleIds.has(pick.id);
          return (
            <Tooltip key={pick.id} text={pick.desc}>
              <Button
                variant={isActive ? 'primary' : 'outline'}
                onClick={() => actions.toggleModule(pick.id)}
                aria-pressed={isActive}
              >
                {`${pick.label} (+${fmtMoney(pick.priceUSD, spec.currency)})`}
              </Button>
            </Tooltip>
          );
        })}
      </div>
    </section>
  );
}